
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import { Tag } from "@/types/tag"

import vSelect from "vue-select"
import api from "@/services/api"
import apiTag from "@/services/api_Tag"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class Tags extends Vue {
	@Prop({ type: Boolean, default: true })
	public alwaysShowLabel!: boolean;

	@Prop()
	canEditCurrentCase!: boolean;

	@Prop({ default: () => [] })
	public value!: Tag[]

	public tagList: Tag[] = [];

	public async mounted () {
		this.tagList = await apiTag.tagList()
	}

	private onCaseTagChanged (updatedTagsList: Tags[]) {
		this.$emit("input", updatedTagsList)
	}
}
